export const GET_PETS_START = 'GET_PETS_START'
export const GET_PETS_SUCC = 'GET_PETS_SUCC'
export const GET_PETS_FAIL = 'GET_PETS_FAIL'

export const SET_CANT_PETS_FOR_PAGINATION = 'SET_CANT_PETS_FOR_PAGINATION'
export const GET_PETS_PAGINATION_START = 'GET_PETS_PAGINATION_START'
export const GET_PETS_PAGINATION_SUCC = 'GET_PETS_PAGINATION_SUCC'
export const GET_PETS_PAGINATION_FAIL = 'GET_PETS_PAGINATION_FAIL'

export const LOGIN_SUCC = 'LOGIN_SUCC'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const LOGIN_USER_DATA = 'LOGIN_USER_DATA'

export const CLEAN_ALERT = 'CLEAN_ALERT'
